export default __webpack_public_path__ + "static/media/9.9bc4e5b2.JPG";